let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kiGNy"), load("2nk6f")]).then(() => parcelRequire('cix6s'));